module.exports = __webpack_public_path__ + "static/img/frank-mckenna-tjX_sniNzgQ-unsplash_thumb.cd7a4fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/frank-mckenna-tjX_sniNzgQ-unsplash_thumb.png
// module id = OFiE
// module chunks = 4